import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Navigator from "./Navigator";
import { ConfigProvider } from "antd";
import { antDTheme } from "./theme";
import { StyleProvider } from "@ant-design/cssinjs";
import Modal from "@Components/Modal/Modal";
import ApiClientProvider from "@Api/Client";
import { lazy, Suspense } from "react";

// Build-time gate: flag lives HERE (not imported from utils/bugReporter) so the
// SDK module isn't pulled into the main bundle. When false, Rollup drops the lazy
// import → `@koderlabs/tasks-sdk*` never ships and the reporter never mounts.
const REPORTER_ENABLED = import.meta.env.VITE_IT_REPORTER_ENABLED === "true";
const BugReporter = REPORTER_ENABLED
  ? lazy(() => import("@Components/BugReporter/BugReporter"))
  : null;

const App = () => {
  return (
    <StyleProvider layer>
      <ConfigProvider theme={antDTheme}>
        <ApiClientProvider>
          <BrowserRouter>
            <Navigator />
            <Modal />
            {/* InstantTasks bug reporter — only bundled when VITE_IT_REPORTER_ENABLED === 'true'. */}
            {BugReporter && (
              <Suspense fallback={null}>
                <BugReporter />
              </Suspense>
            )}
          </BrowserRouter>
        </ApiClientProvider>
      </ConfigProvider>
    </StyleProvider>
  );
};

export default App;
